import React from 'react';
import styled from 'styled-components';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';
import { DocGrid, GridItem } from '../../../components/Styled/grids/editorGrid';

const ThisDocGrid = styled(DocGrid)`
  grid-template-areas:  "code  ratio" "name  name" " not_import412  not_import412" "parent parent" "state_tax state_tax" "local_tax local_tax" ;
  grid-template-columns: 150px 1fr;
  
  @media (max-width: 600px) {
  display: block;
  }
`;

const editorRenderer = (getControl) => (
  <ThisDocGrid>
    <GridItem area="code">
      {getControl('code')}
    </GridItem>
    <GridItem area="name">
      {getControl('name')}
    </GridItem>
  </ThisDocGrid>
);

export default getBaseEditor(editorRenderer, '/api/catalog/kveds/', CommandPanels.catCommandPanel);
